import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';

export const Route = createFileRoute('/(client)/network/(pages)')({
  beforeLoad: async ({ location }) => {
    const { network } = await ensurePermissions();
    if (!network.canRead) throw redirect({ to: '/dashboard' });

    if (location.pathname === '/network' || location.pathname === '/network/') {
      // `search: true` forwards the incoming query string. Without it the
      // router rebuilds the destination search from scratch and drops it, so
      // `/network?view=map` would silently land on the default table view.
      throw redirect({ to: '/network/my-network', search: true });
    }
  },
});
